import React from "react";

function AiChipIcon({ className }) {
  return (
    <svg
      className={className}
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 48 48"
      fill="none"
      aria-hidden="true"
    >
      <path
        stroke="currentColor"
        strokeWidth="2.2"
        strokeLinecap="round"
        d="M16 8V4M24 8V4M32 8V4M16 44v-4M24 44v-4M32 44v-4M8 16H4M8 24H4M8 32H4M44 16h-4M44 24h-4M44 32h-4"
      />
      <rect
        x="10"
        y="10"
        width="28"
        height="28"
        rx="4"
        stroke="currentColor"
        strokeWidth="2.4"
      />
      <rect
        x="16"
        y="16"
        width="16"
        height="16"
        rx="2.5"
        stroke="currentColor"
        strokeWidth="2"
      />
      <text
        x="24"
        y="27.5"
        textAnchor="middle"
        fontFamily="Montserrat, Arial, sans-serif"
        fontSize="9"
        fontWeight="700"
        fill="currentColor"
      >
        AI
      </text>
    </svg>
  );
}

export default AiChipIcon;
